// extracted by mini-css-extract-plugin
module.exports = {"modal":"_2YjlJCf9enm_OHS-N27CKE"};